import React from "react";
import { Card, Icon } from "@telia/teddy";
import "./NavigationCardBlock.less";

type NavigationCardBlockProps = {
    heading: string;
    image?: string;
    url: string;
};

const NavigationCardBlock: React.FC<NavigationCardBlockProps> = ({ url, image, heading }) => {
    return (
        <Card
            className="navigation-card-block"
            layout="navigation-horizontal-small-centered"
            key={url}
            bordered
            variant="white"
        >
            {image && (
                <Card.Illustration>
                    <img width={75} height={75} src={`https://${image}`} alt="" />
                </Card.Illustration>
            )}
            <Card.Heading dangerouslySetInnerHTML={{ __html: heading }} />
            <Card.Button asChild variant="secondary" aria-label="Gå til" iconOnly>
                <a href={url}>
                    <Icon name="arrow-right" aria-hidden="true" focusable="false" />
                </a>
            </Card.Button>
        </Card>
    );
};

export default NavigationCardBlock;
